import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateCashRegisterOperationErrorMapper, CreateCashRegisterOperationDtoMapper } from '../mappers';
import { CreateCashRegisterOperationDto } from '../dtos';

export type ICreateCashRegisterOperationRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateCashRegisterOperationRepo = IRepo<[CreateCashRegisterOperationDto, string | number | undefined], ICreateCashRegisterOperationRepoResponse>;

export const CreateCashRegisterOperationRepoType = Symbol.for('CreateCashRegisterOperationRepo');

@bind(CreateCashRegisterOperationRepoType)
export class CreateCashRegisterOperationRepo implements ICreateCashRegisterOperationRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateCashRegisterOperationDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateCashRegisterOperationDtoMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/cash_categories/edit') : urlMaker('/api/admin/cash_categories/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateCashRegisterOperationErrorMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
